import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ResearchPageDataService {
  apiEP: string = window.apiUrl;
  constructor(private http: HttpClient) {}

  getResearchDocInfo(researchDocId): Observable<any> {
    const jsonData = {
      document_id: researchDocId,
    };
    return this.http.post(`${this.apiEP}/resapi/get_doc_info`, jsonData);
  }

  getDocuments(emailId) {
    const jsonData = {
      analyst_email_id: emailId,
    };
    return this.http.post(`${this.apiEP}/resapi/get_documents`, jsonData);
  }

  getCompanyMapping(symbologyIds): Observable<any> {
    return this.http.get(
      `${
        this.apiEP
      }/api/company_from_symbology_id?symbologycompanyid=${symbologyIds.join(
        "&symbologycompanyid=",
      )}`,
    );
  }

  getResearchDocument(documentId: number): Observable<any> {
    const jsonData = {
      document_id: [documentId],
    };
    return this.http.post(`${this.apiEP}/resapi/get_doc_by_user_jwt`, jsonData);
  }

  getModels(publisherId, companyId): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/show_more_models_api?oneaccess_source_id=${publisherId}&limit=1&symbology_company_id=${companyId}`,
    );
  }

  getDefaultChartData(ticker: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_revenue_line_info/?ticker=${ticker}`,
    );
  }

  searchCompanyLevelLineItems(
    searchString: string,
    symbologyId: number,
  ): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/get_company_level_line_items/?search_string=${searchString}&symbology_id=${symbologyId}`,
    );
  }
}
